import React, { useContext, useEffect, useState } from 'react';
import CombinedContext from 'context/CombinedContext';
import { fetchNavData } from 'containers/Header/actions';
import { requestNav as fetchNav } from 'reducers/nav/actions';
import {
  responseConfig,
  responseMetadata,
  getTranslations,
  responseAsset,
  responseFavorites,
} from 'actions/response';
import { getApiConfig } from 'reducers/response';
import { apiCall, updateSwaggerManager } from 'api';
import API, { updateDefaults } from 'services/api/microfwk';
import { GetRegion, LOCAL_STORAGE_USERHASH } from '../constants';
import { setIntervalSessionValidator } from 'utils/Session';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { getProfileLastTouchFavorited } from 'utils/Socialization';
import { favorited } from 'services/api/user/favorite';
import { get } from 'utils/LocalStorageUtil';
import Utils, { windowUtilsGetMetaMetadata } from 'utils/Utils';
import { GetMeta } from 'utils/getMeta';
import { GetAsset } from 'utils/getAsset';
import apiClaroPagos from 'components/payment/mexico/claro-pagos/api';
import { UserContext } from 'providers/user.provider';
import { jsonParseTraslation } from 'utils/getTranslation';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import useNavExperienceRefresh from 'hooks/useNavExperienceRefresh';
import { useCheckoutRedirect } from 'containers/Payment/hooks/useCheckoutRedirect';
import { getFavoriteContentService } from 'api/services/user/favorites';
import { useNavigate } from 'react-router-dom';
import { getUserToken } from 'utils/user/getUserToken';

const AppSetup = ({ children }) => {
  const context = useContext(CombinedContext);
  const userContext = useContext(UserContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const claroLiteConfig = useSelector(
    selectMetadataKeyByRegion('cv_advertising_config'),
  );
  useNavExperienceRefresh(claroLiteConfig, fetchNav);
  const { handleRedirectCheckoutFromFreemium } = useCheckoutRedirect();
  const userToken = getUserToken();
  const isForgettenPassword = window.location.pathname?.includes(
    'forgottenPassword',
  );
  const { modalVisibility } = useSelector(state => state.resetPassword);

  const checkUpdateInfo = user => {
    const isSSO = get('sso');
    const validEmail = _.get(user, 'validEmail');
    const IsCVEmail = _.get(user, 'email', '').indexOf('@cv') !== -1;
    let validate = validEmail;

    if (validate !== undefined && !validate && IsCVEmail && !isSSO)
      validate = true;
    // if (validate !== undefined && !validate) Utils.openModalUpdateInfo();
  };

  const getClaroPagosConfig = () => {
    try {
      return _.get(windowUtilsGetMetaMetadata('claropagos_configuration'), [
        context?.shiModel?.response?.region,
        'request',
      ]);
    } catch (error) {
      console.warn(`Erorr ==> claro pagosConfig `, error);
      return false;
    }
  };

  const bootNav = async () => {
    await dispatch(fetchNav(navigate, handleRedirectCheckoutFromFreemium));
    await dispatch(fetchNavData());
  };

  //NAVEXPERIENCE CALL
  useEffect(
    () => {
      if (
        isForgettenPassword ||
        modalVisibility ||
        sessionStorage.getItem('changePasswordModal')
      )
        return;
      if (!userToken) return;
      bootNav();
    },
    [userToken],
  );

  //BOOTING LEGACY
  useEffect(() => {
    if (
      isForgettenPassword ||
      modalVisibility ||
      sessionStorage.getItem('changePasswordModal')
    )
      return;

    const bootApaLegacy = async () => {
      dispatch(responseConfig(window.getConfig));
      const { metadataModel, assetModel: assets } = context;
      window.utils.getMeta = new GetMeta(metadataModel);
      window.utils.getAsset = new GetAsset(assets);

      const claroPagosConfig = getClaroPagosConfig();
      if (claroPagosConfig) {
        _.merge(apiClaroPagos.defaults, {
          baseURL: claroPagosConfig.server_url,
        });
      }
    };

    const boot = async () => {
      const apiConfig = getApiConfig(window.getConfig);
      if (userContext.userModel.user_id) {
        const { api_version, ...rest } = apiConfig.params;
        await updateSwaggerManager(apiCall, {
          user_id: userContext.userModel.user_id,
          user_token: userContext.userModel.token,
          ...rest,
        });
      }
      await updateDefaults(API, apiConfig);

      await bootApaLegacy();
      checkUpdateInfo(userContext.userModel);

      const sVTimer = windowUtilsGetMetaMetadata('session_validation_timer');
      const region = GetRegion();
      if (userContext?.userModel?.user_id) {
        setIntervalSessionValidator(sVTimer, region);
      }
      context.setIsAppReady(true);
    };
    boot();
  }, []);

  return <>{children}</>;
};

export default AppSetup;
